export const VERSION = "0.0.2"; // x-release-please-version
